module.exports = __webpack_public_path__ + "161908b58972ebecd3e57fc16ac8cb11.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/outfit-robin-hood.png
// module id = 1356
// module chunks = 0